import { Injectable, inject } from '@angular/core';
import { ChecklistListItemEntity } from '../../../domain/entities/checklist-list-item.entity';
import { ChecklistListState } from '../../states/checklist-list.state';

@Injectable({ providedIn: 'root' })
export class UpdateChecklistInStateUseCase {
  private readonly _state = inject(ChecklistListState);

  public execute(checklist: ChecklistListItemEntity): void {
    this._state.updateChecklist(checklist);
  }
}
